export default __webpack_public_path__ + "static/media/pw-logo-horizontal-color-light.91d9c466.svg";